import { Routes, Route, Navigate } from 'react-router-dom';
import StudentPanel from '../views/student/StudentPanel';
import StudentRegister from '../views/student/StudentRegister';
import StudentData from '../views/student/StudentData';
import StudentGroups from '../views/student/StudentGroups';
import StudentGroupDetailsPage from '../views/student/StudentGroupDetailsPage';
import StudentGroupAddCode  from '../views/student/StudentGrAddCode';
import ExamsUp from '../views/student/ExamsUp';
import ExamsFinish from '../views/student/ExamsFinish';
import ExamWait from '../views/student/ExamWait';
import ExamWer from '../views/student/ExamWer';
import ExamStart from '../views/student/ExamStart';
import ExamInProgress from '../views/student/ExamInProgress';
import ExamFinish from '../views/student/ExamFinish';
import ExamAddCode from '../views/student/ExamAddCode';
import ExamTermStart from '../views/student/ExamTermStart';
import ExamInfo from '../views/student/ExamInfo';
import ExamGrade from '../views/student/ExamGrade';


function StudentRouter({ user }) {
    return (
        <Routes>
            <Route path="/" element={<StudentPanel user={user} />} />
            <Route path="/rejestracja" element={<StudentRegister />} />
            <Route path="moje-konto" element={<StudentData user={user} />} />
            <Route path="grupy" element={<StudentGroups user={user} />} />
            <Route path="grupa/:id" element={<StudentGroupDetailsPage user={user} />} />
            <Route path="grupa/dodaj-kod" element={<StudentGroupAddCode user={user} />} />
            <Route path="egzaminy/zaplanowane" element={<ExamsUp user={user} />} />
            <Route path="egzaminy/zakonczone" element={<ExamsFinish user={user} />} />
            <Route path="egzamin/termin/:termId/start" element={<ExamTermStart  user={user} />} />
            <Route path="egzamin/:id/oczekiwanie" element={<ExamWait user={user} />} />
            <Route path="egzamin/:id/weryfikacja" element={<ExamWer user={user} />} />
            <Route path="egzamin/:id/start" element={<ExamStart user={user} />} />
            <Route path="egzamin/:id/trwa" element={<ExamInProgress user={user} />} />
            <Route path="egzamin/:id/koniec" element={<ExamFinish user={user} />} />
            <Route path="egzamin/:id/wyniki" element={<ExamGrade user={user} />} />
            <Route path="egzamin/:id/info" element={<ExamInfo user={user} />} />
            <Route path="egzamin/dodaj-kod" element={<ExamAddCode user={user} />} />

            <Route path="*" element={<Navigate to="/student" />} />
        </Routes>
    );
}

export default StudentRouter;
